import React, { useState } from "react";
import api from "../api/axios";

const ContactoComercios = () => {
  const [form, setForm] = useState({
    name: "",
    business_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (status.message) setStatus({ type: "", message: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    if (!form.name || !form.business_name || !form.email) {
      setStatus({
        type: "error",
        message: "Por favor completa nombre, comercio y email.",
      });
      return;
    }

    try {
      setLoading(true);
      const res = await api.post("/contact/comercios", form);

      setStatus({
        type: "success",
        message:
          res?.data?.message ||
          "Gracias! Recibimos tu consulta y nos pondremos en contacto a la brevedad.",
      });

      setForm({
        name: "",
        business_name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      setStatus({
        type: "error",
        message:
          error?.response?.data?.error ||
          "Ocurrio un error al enviar el formulario. Intenta nuevamente mas tarde.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Contacto para Comercios</h1>
      <p className="text-secondary mb-4">
        Completa el formulario y te ayudamos a configurar tu primer beneficio en QRBenefits.
      </p>

      <form onSubmit={handleSubmit} style={{ maxWidth: "500px" }}>
        <div className="mb-3">
          <label className="form-label">Nombre completo</label>
          <input
            className="form-control"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Ej: Juan Perez"
            disabled={loading}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Nombre del comercio</label>
          <input
            className="form-control"
            name="business_name"
            value={form.business_name}
            onChange={handleChange}
            placeholder="Ej: Cafeteria La Plaza"
            disabled={loading}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email de contacto</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Ej: contacto@comercio.com"
            disabled={loading}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Telefono / WhatsApp (opcional)</label>
          <input
            className="form-control"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="Ej: +54 9 223..."
            disabled={loading}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Mensaje</label>
          <textarea
            className="form-control"
            name="message"
            rows={4}
            value={form.message}
            onChange={handleChange}
            placeholder="Contanos brevemente sobre tu negocio y que te gustaria lograr con QRBenefits."
            disabled={loading}
          />
        </div>

        {status.message && (
          <div
            className={`alert ${
              status.type === "success" ? "alert-success" : "alert-danger"
            }`}
          >
            {status.message}
          </div>
        )}

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "Enviando..." : "Enviar"}
        </button>
      </form>
    </div>
  );
};

export default ContactoComercios;
